const cargando = document.getElementById('cargando'),
principal = document.getElementById('principal');

document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
    cargando.style.display = 'none';
    principal.style.display = 'block';
  }, 2000);
});